import { t } from "@lingui/macro";
import { format } from "date-fns";

import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { convertServerTimeToLocal } from "@whoosh/utilities/src/dates";

type EventDetailCancelWindowProps = {
  cancelDeadlineAt: string | null;
  wrapperStyle?: any;
};

export const EventDetailCancelWindow = ({
  cancelDeadlineAt,
  wrapperStyle,
}: EventDetailCancelWindowProps) => {
  const currentDate = new Date();
  const currentDateTime = format(currentDate, "yyyy-MM-dd HH:mm:ss");

  const formattedCancelDeadlineAt = cancelDeadlineAt
    ? format(convertServerTimeToLocal(cancelDeadlineAt), "yyyy-MM-dd HH:mm:ss")
    : null;

  const displayCancelDeadlineAt = cancelDeadlineAt
    ? format(convertServerTimeToLocal(cancelDeadlineAt), "MMM do 'at' h:mm aa")
    : null;

  const isInCancelWindowRange = formattedCancelDeadlineAt
    ? currentDateTime < formattedCancelDeadlineAt
    : true;

  return (
    <Box
      width="100%"
      justifyContent="center"
      alignContent="center"
      style={{
        ...{
          backgroundColor: isInCancelWindowRange
            ? "main-primary-1000"
            : "#EDE1A1",
        },
        ...wrapperStyle,
      }}
    >
      {isInCancelWindowRange && formattedCancelDeadlineAt ? (
        <Text textAlign="center" color="text-primary" fontSize={10} padding={2}>
          {t`Cancellation available until`} {`${displayCancelDeadlineAt}`}
        </Text>
      ) : isInCancelWindowRange ? (
        <Text textAlign="center" color="text-primary" fontSize={10} padding={2}>
          {t`Cancellation available`}
        </Text>
      ) : (
        <Text
          textAlign="center"
          color="text-primary"
          fontSize={10}
          padding={2}
        >{t`Cancellation not allowed`}</Text>
      )}
    </Box>
  );
};
